import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmpresaEditarComponent } from './empresa-editar.component';




@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: EmpresaEditarComponent }    
    ])],
    exports: [RouterModule]
})
export class EmpresaEditarRoutingModule { }
